/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_OutbidInputs */

const en_directory_vibebids_outbid = /** @type {(inputs: Directory_Vibebids_OutbidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbid`)
};

const zh_directory_vibebids_outbid = /** @type {(inputs: Directory_Vibebids_OutbidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出价超过`)
};

/**
* | output |
* | --- |
* | "Outbid" |
*
* @param {Directory_Vibebids_OutbidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_outbid = /** @type {((inputs?: Directory_Vibebids_OutbidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_OutbidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_outbid(inputs)
	return zh_directory_vibebids_outbid(inputs)
});
export { directory_vibebids_outbid as "directory.vibebids.outbid" }